var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.786,
    height: 15,
    viewBox: "0 0 11.786 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33",
    "data-name": "Layer 33",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67647",
    "data-name": "Path 67647",
    d: "M9.821,3.607V15.393A1.607,1.607,0,0,1,8.214,17H6.607A1.607,1.607,0,0,1,5,15.393V3.607A1.607,1.607,0,0,1,6.607,2H8.214A1.607,1.607,0,0,1,9.821,3.607ZM15.179,2H13.571a1.607,1.607,0,0,0-1.607,1.607V15.393A1.607,1.607,0,0,0,13.571,17h1.607a1.607,1.607,0,0,0,1.607-1.607V3.607A1.607,1.607,0,0,0,15.179,2Z",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.b754343d9d3699fca9fbe355cf8beec6.svg";
export { ForwardRef as ReactComponent };